import SpriteSymbol from "../../../../../../../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../../../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "facebook-solid",
  "use": "facebook-solid-usage",
  "viewBox": "0 0 32 32",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\" id=\"facebook-solid\"><path fill=\"var(--bolt-theme-icon, currentColor)\" d=\"M26 0a6 6 0 016 6v20a6 6 0 01-6 6h-4V19.6h4.2l.6-4.8h-4.7v-3.1c0-1.4.4-2.3 2.4-2.3H27V5a33.8 33.8 0 00-3.7-.2c-3.7 0-6.2 2.3-6.2 6.4v3.6h-4.2v4.8h4.2V32H6a6 6 0 01-6-6V6a6 6 0 016-6z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol